module.exports = __webpack_public_path__ + "static/media/CAMARONAJO_MENU-normal.8105a205.png";